import { Box, Tab, Tabs, Typography, useTheme } from '@mui/material'
import { FC, SyntheticEvent, useState } from 'react'
import { PrivateFoundations } from './PrivateFoundations'
import { SmallBusinessAndFederal } from './SmallBusinessAndFederal'

const TAB_HEADER = ['Small business', 'Federal grants', 'Private foundations']

export const RecentMatches: FC = () => {
  const theme = useTheme()

  const [selectedTab, setSelectedTab] = useState('Small business')

  const handleTabChange = (event: SyntheticEvent, newTab: string) => {
    setSelectedTab(newTab)
  }

  return (
    <Box>
      <Typography mb={1} fontSize="1rem" fontWeight={600} color="secondary">
        Recent matches
      </Typography>

      <Tabs
        value={selectedTab}
        textColor={'primary'}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        onChange={handleTabChange}
        sx={{ borderBottom: `1px solid ${theme.palette.grey[300]}` }}
      >
        {TAB_HEADER.map((header) => (
          <Tab
            key={header}
            value={header}
            label={
              <Typography
                textAlign="left"
                fontSize="0.9rem"
                textTransform="none"
                fontWeight={theme.typography.fontWeightMedium}
              >
                {header}
              </Typography>
            }
          />
        ))}
      </Tabs>

      {selectedTab === 'Small business' && <SmallBusinessAndFederal grantType={['sbir', 'sttr']} />}
      {selectedTab === 'Federal grants' && <SmallBusinessAndFederal grantType={['federal']} />}
      {selectedTab === 'Private foundations' && <PrivateFoundations />}
    </Box>
  )
}
